<div class="page-container">
    <div class="header-section">
        <lib-breadcrumb *ngIf="breadcrumbs" [list]="breadcrumbs"></lib-breadcrumb>
        <h2 class="page-title">{{ pageTitle }}</h2>
    </div>

    <!-- Search Criteria Panel -->
    <div class="content-wrapper">
        <form [formGroup]="searchForm" (ngSubmit)="handleSearch()" class="search-form-card">
            <div class="search-grid">
                <div class="form-item">
                    <mat-label>Username</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput formControlName="userName" />
                        <div *ngIf="searchForm.get('userName')?.touched && searchForm.get('userName')?.errors">
                            <span *ngIf="searchForm.get('userName')?.errors?.['required']">
                                Username is required
                            </span>

                            <span *ngIf="searchForm.get('userName')?.errors?.['specialChars']">
                                Special characters are not allowed
                            </span>
                            </div>
                    </mat-form-field>
                </div>
                <div class="form-actions">
                    <button type="reset" mat-stroked-button color="primary" [disabled]="isLoading"
                        (click)="handleFormReset()">Reset</button>
                    <button type="submit" mat-flat-button color="primary"
                        [disabled]="searchForm.invalid || isLoading">Search</button>
                </div>
            </div>
        </form>

        <!-- Table Results Panel -->
        <div class="section-container" *ngIf="hasSearched || isLoading">
            <div class="section-header">
                <h3 class="heading">Reset Password</h3>
                <div class="action-toolbar">
                    <button mat-button color="primary"
                        [disabled]="selectedRows.length === 0 || isLoading || !hasSearched"
                        (click)="handleResetPassword()"><mat-icon>lock_reset</mat-icon> Reset Password</button>
                </div>
            </div>
            
            <mat-progress-bar *ngIf="isLoading" mode="indeterminate"
                style="position: absolute; top: 0; left: 0; right: 0; z-index: 20;"></mat-progress-bar>
                
            <div class="responsive-table-wrapper">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0">

                    <!-- Selection Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef class="w-10"></th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isSelected(element)" [disabled]="isLoading"
                                (change)="toggleSelection(element, $event.checked)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="partyId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="partyId"> Party ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.partyId}} </td>
                    </ng-container>

                    <ng-container matColumnDef="userName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="userName"> Username </th>
                        <td mat-cell *matCellDef="let element"> {{element.userName}} </td>
                    </ng-container>

                    <ng-container matColumnDef="emailAddress">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="emailAddress"> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.emailAddress}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
        </div>
    </div>
</div>
